import $config from '@/config';
import axios from 'axios';
import Cookies from 'react-cookies';

export const getUrlKey = (name) => (
    decodeURIComponent(
        // eslint-disable-next-line no-sparse-arrays
        (new RegExp(`[?|&]${name}= ([^&;]+?)(&|#|;|$)`).exec(window.location.href) || [''])[1].replace(/\+/g, '%20')
    ) || null
);

export const getBaseUrl = () => {
    let baseUrl = '';
    switch (process.env.NODE_ENV) {
        case 'development':
        // 这里是本地的请求url
            baseUrl = $config.apiUrl.dev;
            break;
        case 'production':
        // 生产环境url
            baseUrl = $config.apiUrl.pro;
            break;
        default:
            baseUrl = $config.apiUrl.pro;
            break;
    }
    return baseUrl;
};

export const getSocketUrl = () => {
    let socketUrl = '';
    switch (process.env.NODE_ENV) {
        case 'development':
            // 这里是本地的请求url
            socketUrl = $config.apiUrl.socket_dev;
            break;
        case 'production':
            // 生产环境url
            socketUrl = $config.apiUrl.socket_pro;
            break;
        default:
            socketUrl = $config.apiUrl.socket_pro;
            break;
    }
    return socketUrl;
};

/**
   * 下载文件
   * @param data
   * @param filename
   */
  export const downLoadFile = (data, filename) => {
    if (typeof window.chrome !== 'undefined') {
        // Chrome version
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(data);
        link.download = filename;
        link.click();
    } else if (typeof window.navigator.msSaveBlob !== 'undefined') {
        // IE version
        const blob = new Blob([data], { type: 'application/force-download' });
        window.navigator.msSaveBlob(blob, filename);
    } else {
        // Firefox version
        const file = new File([data], filename, { type: 'application/force-download' });
        window.open(URL.createObjectURL(file));
    }
};

/**
    * 获取文件下载信息
    * @param url
    * @param params
    * @param fileName
    */
export const getDownLoadFile = (url, params, fileName) => {
    axios({
        method: 'get',
        url,
        params,
        responseType: 'blob'
    }).then((res) => {
        downLoadFile(res.data, fileName);
    });
};

/**
    * 触发 window.resize
    */
export function triggerWindowResizeEvent() {
    const event = document.createEvent('HTMLEvents');
    event.initEvent('resize', true, true);
    event.eventType = 'message';
    window.dispatchEvent(event);
}

/**
 * 多个数组合并并去重
 * @param array1
 * @param array2
 * @param array1
 * @param array2
 */
export const listConcatUnique = (array1, array2) => {
    array1.map((v) => {
        if (v !== '') {
            const idx = array2.indexOf(v);
            if (idx > -1) {
                array2.splice(idx, 1);
            }
        }
        return array2;
    });
    array1 = array1.concat(array2);
    return array1;
};

/**
     * 获取指定数据字典中指定value的label
     * @param dictList
     * @param value
     * @returns {boolean|*}
     */
export const getDictLabel = (dictList, value) => {
    let label = '';
    dictList.forEach((item) => {
        if (item.dictValue === value) {
            label = item.dictLabel;
        }
    });
    return label;
};

/**
 * 数组对象去重
 * @param array
 * @param key
 * @returns {string}
 */
 export const arrayUnique = (array, key) => {
    if (key) {
    const res = new Map()
    return array.filter((array) => !res.has(array[key]) && res.set(array[key], 1))
    } else {
    const arr = new Set()
    array.map(item => {
        arr.add(item)
    })
    return arr
    }
 }

/**
 * 数据排序
 * @param data
 * @param key
 * @param type
 * @returns {*}
 */
export const sortDataByKey = (data, key, type) => {
    data.map((item) => {
        if (item.children && item.children.length > 1) {
            sortDataByKey(item.children, key, type);
        }
        return item;
    });
    if (type && type === 'asc') {
        return data.sort((a, b) => {
            const x = a[key] ? a[key] : 0;
            const y = b[key] ? b[key] : 0;
            return ((x < y) ? -1 : (x > y) ? 1 : 0);
        });
    } if (type && type === 'desc') {
        return data.sort((a, b) => {
            const x = a[key] ? a[key] : 0;
            const y = b[key] ? b[key] : 0;
            return ((x > y) ? -1 : (x < y) ? 1 : 0);
        });
    }
    return data.sort((a, b) => {
        const x = a[key] ? a[key] : 0;
        const y = b[key] ? b[key] : 0;
        return ((x < y) ? -1 : (x > y) ? 1 : 0);
    });
};

/**
 *  实际的递归函数，将会变化的参数抽取出来
 * @param array
 * @param startPid
 * @param currentDept
 * @param opt
 * @returns {Array}
 */
    export const listToTree = (array, startPid, currentDept, opt) => {
        if (opt.maxDept < currentDept) {
          return []
        }
        let child = []
        if (array && array.length > 0) {
          child = array.map(item => {
            // 筛查符合条件的数据（主键 = startPid）
            if (typeof item[opt.parentKey] !== 'undefined' && item[opt.parentKey] === startPid) {
              // 满足条件则递归
              const nextChild = listToTree(array, item[opt.primaryKey], currentDept + 1, opt)
              // 节点信息保存
              if (nextChild.length > 0) {
                item['hasChild'] = true
                item[opt.childKey] = nextChild
              } else {
                item['hasChild'] = false
              }
              return item
            }
          }).filter(item => {
            return item !== undefined
          })
        }
        return child
    };

    export const listConvertTreeNoTop = (array, opt) => {
        const obj = {
            primaryKey: opt.primaryKey || 'id',
            parentKey: opt.parentKey || 'pid',
            startPid: opt.startPid || -1,
            currentDept: opt.currentDept || 0,
            maxDept: opt.maxDept || 100,
            childKey: opt.childKey || 'children'
        };
        return listToTreeNoTop(array, obj.startPid, obj.currentDept, obj);
    };

/**
 *  实际的递归函数，将会变化的参数抽取出来
 * @param array
 * @param startPid
 * @param currentDept
 * @param opt
 * @returns {Array}
 */
 export const listToTreeNoTop = (array, startPid, currentDept, opt) => {
    if (opt.maxDept < currentDept) {
      return []
    }
    let child = []
    if (array && array.length > 0) {
      child = array.map(item => {
        // 筛查符合条件的数据（主键 = startPid）
        if (startPid !== 'id') {
            if (typeof item[opt.parentKey] !== 'undefined' && item[opt.parentKey] === startPid) {
                // 满足条件则递归
                const nextChild = listToTree(array, item[opt.primaryKey], currentDept + 1, opt)
                // 节点信息保存
                if (nextChild.length > 0) {
                  item['hasChild'] = true
                  item[opt.childKey] = nextChild
                } else {
                  item['hasChild'] = false
                }
                return item
              }
        } else {
            const nextChild = listToTree(array, item.id, currentDept + 1, opt)
            if (nextChild.length > 0) {
                item['hasChild'] = true
                item[opt.childKey] = nextChild
              } else {
                item['hasChild'] = false
              }
              return item
        }
      }).filter(item => {
        return item !== undefined
      })
    }
    return child
};

/**
     *部门排序
     */
export const sortDeptBykey = (data) => {
    data.map((item) => {
        if (item.children && item.children.length > 1) {
            sortDeptBykey(item.children);
        }
        return item;
    });
    return data.sort((a, b) => {
        const x = a.seq ? window.parseInt(a.seq) : 0;
        const y = b.seq ? window.parseInt(b.seq) : 0;
        return ((x < y) ? -1 : (x > y) ? 1 : 0);
        // return ((x > y) ? -1 : (x < y) ? 1 : 0)
    });
};

/**
 * 将普通列表无限递归转换为树
 * @param array
 * @param {{parentKey: string, startPid: string, primaryKey: string}} opt [配置参数，支持 primaryKey(主键 默认id) parentKey(父级id对应键 默认pid) nameKey(节点标题对应的key 默认name) valueKey(节点值对应的key 默认id) checkedKey(节点是否选中的字段 默认checked，传入数组则判断主键是否在此数组中) startPid(第一层扫描的PID 默认0) currentDept(当前层 默认0) maxDept(最大递归层 默认100) childKey(递归完成后子节点对应键 默认list) deptPrefix(根据层级重复的前缀 默认'')]
 * @return {[type]}            [description]
 */
export const listConvertTree = (array, opt) => {
    const obj = {
        primaryKey: opt.primaryKey || 'id',
        parentKey: opt.parentKey || 'pid',
        startPid: opt.startPid || -1,
        currentDept: opt.currentDept || 0,
        maxDept: opt.maxDept || 100,
        childKey: opt.childKey || 'children'
    };
    return listToTree(array, obj.startPid, obj.currentDept, obj);
};

export const getDataChildrenIds = (data) => {
    let str = '';
    data.map((item) => {
        str += `${item.id},`;
        if (item.children && item.children.length > 0) {
            str += getDataChildrenIds(item.children);
        }
        return item;
    });
    return str;
};

/**
     * 获取数组中指定数据及其子数据的id值，用 , 拼接字符串
     * @param data
     * @param id
     */
export const getDataIds = (data, id) => {
    let str = '';
    data.map((item) => {
        if (item.id === id) {
            if (item.parentId === '0') {
                str = '';
            } else {
                str += `${id},`;
                if (item.children && item.children.length > 0) {
                    str += getDataChildrenIds(item.children);
                }
            }
        } else if (item.children && item.children.length > 0) {
            str += getDataIds(item.children, id);
        }
        return item;
    });
    if (str.lastIndexOf(',') === (str.length - 1)) {
        str = str.substring(0, str.length - 1);
    }
    return str;
};

/**
     * 获取树中指定 key 的字符串拼接 用 / 拼接
     * @param data 树
     * @param key 用于拼接的键
     * @param strs 用于拼接的字符
     * @returns {string}
     */
export const getChildrenStr = (data, key, strs) => {
    let str = '';
    data.map((item) => {
        if (item.parentId !== '0') {
            str += item[key] + strs;
        }
        if (item.children && item.children.length > 0) {
            str += getChildrenStr(item.children, key, strs);
        }
        return item;
    });
    if (str.lastIndexOf(strs) === (str.length - 1)) {
        str = str.substring(0, str.length - 1);
    }
    return str;
};

/**
 * 遍历组织树，设置组织树中的key,title,children
 */
export const replaceTreeFields = (treeData) => {
    if (treeData && treeData.length > 0) {
        treeData.map(item => {
            item.key = item.id
            item.value = item.id
            item.title = item.menuName || item.name || item.areaName || item.actionName
            if (item.childNum !== undefined) {
                if (item.childNum === 0) {
                    item.isLeaf = true
                    item.children = undefined
                } else {
                    item.isLeaf = false
                }
            } else {
                if (item.childrenNum === 0) {
                    item.isLeaf = true
                } else {
                    item.isLeaf = false
                }
            }
            if(item.children && item.children.length > 0){
                item.children = replaceTreeFields(item.children)
            }
            if(item.actionList && item.actionList.length > 0){
                item.children = replaceTreeFields(item.actionList)
            }
        })
        return treeData;
    }
}

export const replaceTreeFields2 = (treeData) => {
    if (treeData && treeData.length > 0) {
        treeData.map(item => {
            item.key = item.id
            item.value = item.id
            item.title = item.menuName || item.name || item.areaName
            if(item.children && item.children.length > 0){
                item.isLeaf = false
                item.children = replaceTreeFields2(item.children)
            } else {
                item.isLeaf = true
            }
            if(item.actionList && item.actionList.length > 0){
                item.children = replaceTreeFields2(item.actionList)
            }
        })
        return treeData;
    }
}

/**
 * 向树结构中添加children
 */
export const addTreeChildren = (tree,id,children) => {
    tree.map(item => {
        if(item.id === id){
            if(item.children && item.children.length > 0){
                item.children.map(it=>{
                    children = children.filter(i => i.id !== it.id)
                })
                children.map(i => {
                    item.children.push(i)
                })
            }else{
                item.children = children
            }
        } else if(item.children && item.children.length > 0){
            addTreeChildren(item.children,id,children)
        }
    })
    return tree;
}

/**
 * 树结构转数字
 */
export const treeToArray = (tree) => {
    const list = []
    tree.map(item=>{
        if(item.children && item.children.length > 0){
            const childrenList = treeToArray(item.children)
            childrenList.map(it=>{
                list.push(it)
            })
        }
        list.push(item)
    })
    return list;
}

/**
 * @param list  当前数组
 * @param id 当前对象ID
 * @param childrenList   Terr树子级数组
 * @returns {*}
 */
export const updateTreeData = (list, id, childrenList) => {
    if (list && list.length > 0) {
        return list.map((item) => {
            if (item.id === id) {
                return {...item, children : childrenList}
            } else if((item.childNum > 0 && item.children && item.children.length > 0) || (item.childrenNum > 0 && item.children && item.children.length > 0)){
                return {...item, children : updateTreeData(item.children, id, childrenList)}
            }
            return item
        })
    }
}

export const getToken = () => {
    const token = Cookies.load('user_token')
    if (token && token !== 'undefined') {
      return token
    } else {
      return false
    }
  }

export const getAuthorization = () => {
    const headers = {}
    const token = getToken()
    if (token) {
      headers['Authorization'] = token
    }
    return headers
  }
  // 数据字典属性转换
export const dictionariesType = (arr) => {
    let list = []
    if (arr) {
        arr.map(item => {
            item.name = item.dictLabel
            item.value = item.dictValue
            item.id = item.dictValue
            list.push(item)
        })
        return list
    }
}
  // 树下拉框 转换自定义节点展示必备属性
  export const getTreeSelectNodesInfo = (arr,label,id,children) => {
    if (arr) {
        arr.map(item => {
            item.title = item[label]
            item.value = item[id]
            item.children = item[children]
            if (item.children.length > 0) {
                getTreeSelectNodesInfo(item.children,label,id,children)
            }
            return item
        })
        return arr
    } else {
        return []
    }
}
/**
 * 判断是否具有按钮权限
 * @param str
 * @returns {boolean}
 */
export const hasPermissions = (str) => {
    const userStr = localStorage.getItem('userInfo')
    if(userStr && userStr.length > 0){
        const userInfo = JSON.parse(userStr)
        if(userInfo.loginName && (userInfo.loginName === 'admin' || userInfo.loginName === 'manager')){
            return true
        }else {
            const authorities = userInfo.authorities
            return authorities.filter(item => item === str).length > 0;
        }
    }
    return false
}
/**
 * 判断是否是创建人
 * @param str
 * @returns {boolean}
 */
export const isCreatePeople = (str) => {
    const userStr = localStorage.getItem('userInfo')
    if(userStr && userStr.length > 0){
        const userInfo = JSON.parse(userStr)
        if(userInfo.userId && userInfo.userId === str){
            return true
        }
        if (userInfo.id === str) {
            return true
        }
    }
    return false
}
/**
 * 判断是否点击过巡检工单受理
 * @param array
 * @returns {boolean}
 */
export const hasInspectionAccept = (array) => {
    const userStr = localStorage.getItem('userInfo')
    let isFlg = true
    if(userStr && userStr.length > 0){
        const userInfo = JSON.parse(userStr)
        if (array && array.length>0){
            array.map(e=>{
                if (e.handlerId === userInfo.userId){
                    isFlg = false
                    return isFlg
                }
            })

        }
    }
    return isFlg
}
//设施属性转换
export const facilities = (arr) => {
    let list = []
    if (arr) {
        arr.map(item => {
            item.name = item.instName
            item.value = item.id
            list.push(item)
        })
        return list
    }
}
//用户属性类型转换
export const userTransformation = (arr) => {
    let list = []
    if (arr) {
        arr.map(item => {
            item.name = item.realName
            item.value = item.id
            list.push(item)
        })
        return list
    }
}

/**
 * 防抖
 * @param func
 * @param wait
 */
export function deBounce(func, wait) {
    let timeOut = null;
    return function (...args) {
        clearTimeout(timeOut)
        timeOut = setTimeout(() => {
            func(...args)
        }, wait)
    }
}

/**
 * 设施表单列表中某个属性的值
 * @param formList 表单列表
 * @param key 属性key
 * @param value 属性值
 * @param valueType 值类型： value;list
 */
export function setFormListValueByKey(formList,key,value,valueType){
    if(formList){
        formList.map(item => {
            if(item.key === key){
                switch(valueType){
                    case 'value': item.value = value;break;
                    case 'list': item.list = value;break;
                    default:break;
                }
            }
        })
    }
    return formList
}
export function setFormListOptionByKey(formList,itemKey,optionKey,optionValue){
    if(formList){
        formList.map(item => {
            if(item.key === itemKey){
                item[`${optionKey}`] = optionValue
            }
        })
    }
    return formList
}

export function setFormListOptionsByOptionList(formList,optionList){
    if(formList && optionList){
        formList.map(item => {
            optionList.map(option => {
                if(item.key === option.itemKey){
                    option.options.map(op => {
                        item[`${op.optionKey}`] = op.optionValue
                    })
                }
            })
        })
    }
    return formList
}

export function downloadFile(url){
    // eslint-disable-next-line no-undef
    // const buf = Buffer.from(content, 'binary')
    let fileUrl = `${getBaseUrl()}/file/files${url}`
    let a = document.createElement('a')
    // 指定生成的文件名
    a.href = fileUrl
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
}

/**
 * 获取两个时间的差值 转换成几天几时几分
 * createTime 开始时间
 * updateTime结束时间
 * */
 export const getTimeDifference = (createTime, updateTime, status) => {
	if (!createTime || createTime === '') {
		return
	}
	if (status === 'reject' || status === 'completed') {
		return ''
	}
	const date1 = createTime//开始时间
	const date2 = updateTime //结束时间
	const date3 = new Date(date2).getTime() - new Date(date1).getTime() //时间差的毫秒数
	// //计算出相差天数
	const days = Math.floor(date3 / (24 * 3600 * 1000))
	// //计算出小时数
	const leave1 = date3 % (24 * 3600 * 1000) //计算天数后剩余的毫秒数
	const hours = Math.floor(leave1 / (3600 * 1000))
	// //计算相差分钟数
	const leave2 = leave1 % (3600 * 1000) //计算小时数后剩余的毫秒数
	const minutes = Math.floor(leave2 / (60 * 1000))
	// //计算相差秒数
	const leave3 = leave2 % (60 * 1000) //计算分钟数后剩余的毫秒数
	const seconds = Math.round(leave3 / 1000)
	const text =  (days + '天' + hours + '小时 ' + minutes + '分钟').replace(/-/g, '')
	const value = text.replace(' ', '')
	return value
}
